// Barra superior como la del editor de Framer (ficha 02): botón de modo a la izquierda, nombre en el centro,
// avatar y acciones a la derecha.
import type { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { useApp } from '../store.ts';
import { LogoMark } from './Logo.tsx';
import { Menu, useMenuState, type MenuEntry } from './Menu.tsx';

export function Avatar() {
  const me = useApp((s) => s.me);
  const initials = (me?.name ?? '?')
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <span className="avatar" title={me?.email}>
      {initials}
    </span>
  );
}

export function TopBar(props: { mode: string; menu: MenuEntry[]; center: ReactNode; right?: ReactNode }) {
  const m = useMenuState();
  return (
    <header className="topbar">
      <div className="left">
        <button ref={m.anchor} type="button" className="mode-button" onClick={m.toggle} aria-haspopup="menu" aria-expanded={m.open}>
          <LogoMark height={14} className="mark" />
          <span>{props.mode}</span>
          <ChevronDown size={10} color="var(--text-2)" />
        </button>
        <Menu anchor={m.anchor} open={m.open} onClose={m.close} items={props.menu} width={240} />
      </div>
      <div className="center">{props.center}</div>
      <div className="right">
        <Avatar />
        {props.right}
      </div>
    </header>
  );
}
